import { NAVIGATION_RECEIVE, NAVIGATION_TOP_LEVEL_OPEN } from '../constants';
export const navigation = (state = { menu: [], topLevelOpen: false }, action) => {
    switch (action.type) {
        case NAVIGATION_RECEIVE:
        case NAVIGATION_TOP_LEVEL_OPEN:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
